module.exports = __webpack_public_path__ + "static/media/Terms.c3be6d62.md";